import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import LoadingButton from '@atlaskit/button/loading-button';
import { checkSubmitDisabled } from './utils';
export var messages = defineMessages({
  saveButton: {
    id: 'fabric.linkPicker.button.save',
    defaultMessage: 'Save',
    description: 'Button to save edited link'
  },
  insertButton: {
    id: 'fabric.linkPicker.button.insert',
    defaultMessage: 'Insert',
    description: 'Button to insert searched or selected link'
  }
});
export var LinkPickerSubmitButton = function LinkPickerSubmitButton(_ref) {
  var isEditing = _ref.isEditing,
    isLoading = _ref.isLoading,
    isSubmitting = _ref.isSubmitting,
    customSubmitButtonLabel = _ref.customSubmitButtonLabel,
    error = _ref.error,
    items = _ref.items,
    queryState = _ref.queryState,
    submitMessageId = _ref.submitMessageId,
    testId = _ref.testId,
    url = _ref.url;
  var intl = useIntl();
  var insertButtonMsg = isEditing ? messages.saveButton : messages.insertButton;
  var isSubmitDisabled = checkSubmitDisabled(isLoading, isSubmitting, error, url, queryState, items);
  return /*#__PURE__*/React.createElement(LoadingButton, {
    type: "submit",
    appearance: "primary",
    testId: testId,
    isDisabled: isSubmitDisabled,
    "aria-labelledby": isSubmitting ? submitMessageId : undefined,
    isLoading: isSubmitting
  }, customSubmitButtonLabel ? intl.formatMessage(customSubmitButtonLabel) : intl.formatMessage(insertButtonMsg));
};